/**
 * player-url.js
 * Synchronise le choix du joueur (Globo Product Options) avec l'URL.
 *   Choix du joueur "33 - Pasche"  ->  ?joueur=33-pasche
 *   Ouverture de ?joueur=33-pasche ->  joueur présélectionné
 */
(function () {
  'use strict';

  var PARAM = 'joueur';
  var SELECT_SELECTOR = '.gpo-app select[data-field-name="Joueur"]';
  var FLOCAGE_SELECTOR = '.gpo-app input[type="radio"][data-field-name="Flocage"]';
  var FLOCAGE_JOUEUR_VALUE = 'Joueur';

  // "81 - Baragaño" -> "81-baragano"
  function slug(str) {
    return String(str)
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function getParam() {
    return new URL(window.location.href).searchParams.get(PARAM);
  }

  function setParam(value) {
    var url = new URL(window.location.href);
    if (value) url.searchParams.set(PARAM, value);
    else url.searchParams.delete(PARAM);
    history.replaceState(history.state, '', url);
  }

  function fire(el) {
    el.dispatchEvent(new Event('input', { bubbles: true }));
    el.dispatchEvent(new Event('change', { bubbles: true }));
  }
  // --- Galerie : affiche l'image du joueur
  var SLIDE_SELECTOR = 'media-gallery slideshow-slides slideshow-slide';

  function showPlayerImage(playerSlug) {
    var slideshow = document.querySelector('media-gallery slideshow-component');
    var slides = document.querySelectorAll(SLIDE_SELECTOR);
    if (!slideshow || !slides.length) return;

    var index = 0; // par défaut : première image (aucun joueur / pas d'image dédiée)

    if (playerSlug) {
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (!img) continue;
        var haystack = slug(img.getAttribute('alt') || '') + ' ' + slug(img.getAttribute('src') || '');
        if (haystack.indexOf(playerSlug) !== -1) {
          index = i;
          break;
        }
      }
      // pas d'image trouvée pour ce joueur : on ne bouge pas
      if (index === 0 && !matches(slides[0], playerSlug)) return;
    }

    goToSlide(slideshow, index);
  }

  function matches(slide, playerSlug) {
    var img = slide.querySelector('img');
    if (!img) return false;
    var h = slug(img.getAttribute('alt') || '') + ' ' + slug(img.getAttribute('src') || '');
    return h.indexOf(playerSlug) !== -1;
  }

  function goToSlide(slideshow, index) {
    if (typeof slideshow.select === 'function') {
      slideshow.select(index);
      return;
    }
    // Repli : clic sur la miniature (desktop) ou le point (mobile)
    var btn =
      slideshow.querySelectorAll('.slideshow-controls__thumbnail')[index] ||
      slideshow.querySelectorAll('.slideshow-controls__dots button')[index];
    if (btn) btn.click();
  }
  // --- 1. Choix d'un joueur -> mise à jour de l'URL (délégation d'événements :
  //        continue de fonctionner si Globo ré-affiche ses options)
  document.addEventListener('change', function (e) {
    var target = e.target;
    if (!target || !target.matches) return;

    if (target.matches(SELECT_SELECTOR)) {
      var s = target.value ? slug(target.value) : null;
      setParam(s);
      showPlayerImage(s);          // <-- nouveau
    }

    if (target.matches(FLOCAGE_SELECTOR) && target.value !== FLOCAGE_JOUEUR_VALUE) {
      setParam(null);
      showPlayerImage(null);       // <-- nouveau : retour à la 1re image
    }
  });

  // --- 2. Au chargement : présélection depuis l'URL
  function preselect() {
    var wanted = getParam();
    if (!wanted) return true; // rien à faire

    var select = document.querySelector(SELECT_SELECTOR);
    if (!select || select.options.length < 2) return false; // Globo pas encore prêt

    // S'assure que le flocage "Joueur" est actif (sinon le select reste masqué)
    var radios = document.querySelectorAll(FLOCAGE_SELECTOR);
    for (var r = 0; r < radios.length; r++) {
      if (radios[r].value === FLOCAGE_JOUEUR_VALUE && !radios[r].checked) {
        radios[r].click();
      }
    }

    for (var i = 0; i < select.options.length; i++) {
      if (slug(select.options[i].value) === wanted) {
        select.value = select.options[i].value;
        fire(select);
        return true;
      }
    }
    return true; // joueur inconnu : on ignore
  }

  // Globo injecte ses options en JS : on réessaie pendant ~10 s maximum
  var tries = 0;
  var timer = setInterval(function () {
    if (preselect() || ++tries > 50) clearInterval(timer);
  }, 200);
})();